module.exports = __webpack_public_path__ + "static/img/image-005.aab0bbd9.jpeg";